type AnswerPositionLike = {
    id?: string | number | null
    position?: string | number | null
}

type QuestWithSortedAnswers = {
    id?: string | number | null
    space_id?: string | number | null
    sorted_answers?: AnswerPositionLike[] | null
}

export const INSERT_ANSWER_PLACEHOLDER_FLAG = '__insert_answer_placeholder'

export function isInsertAnswerPlaceholder(answer: unknown): boolean {
    return Boolean(
        answer &&
            typeof answer === 'object' &&
            (answer as Record<string, unknown>)[INSERT_ANSWER_PLACEHOLDER_FLAG],
    )
}

export function insertedAnswerPosition(
    quest: QuestWithSortedAnswers | null | undefined,
    beforeAnswerId: string | number | null | undefined,
): number | undefined {
    const answers = Array.isArray(quest?.sorted_answers) ? quest.sorted_answers : []
    const ix = answers.findIndex(answer => String(answer?.id) === String(beforeAnswerId))
    const answer = ix >= 0 ? answers[ix] : null
    const answerPosition = Number(answer?.position)

    if (!Number.isFinite(answerPosition)) return undefined
    if (ix === 0) return answerPosition / 2

    const previousPosition = Number(answers[ix - 1]?.position)
    if (!Number.isFinite(previousPosition)) return undefined

    return (previousPosition + answerPosition) / 2
}

function stringId(value: string | number | null | undefined): string | undefined {
    return value == null ? undefined : String(value)
}

export function insertedAnswerPlaceholderParams(
    quest: QuestWithSortedAnswers,
    beforeAnswerId: string | number | null | undefined,
) {
    return {
        quest_id: stringId(quest.id),
        space_id: stringId(quest.space_id),
        position: insertedAnswerPosition(quest, beforeAnswerId),
        is_draft: false,
        [INSERT_ANSWER_PLACEHOLDER_FLAG]: true,
    }
}
